import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import React from 'react';
import {useProductSelectionSection} from '../useGetProductBulkSection';
import {
  ProductSelectionGridSkeleton,
  ProductSelectionSkeleton,
} from './ProductSelectionSkeleton';
import {
  ProductSelectionView,
  ProductSelectionViewProps,
} from './ProductSelectionView';

export const ProductSelection = (
  props: ProductSelectionViewProps &
    PriorityConfig & {
      ref?: React.Ref<HTMLElement>;
    },
) => {
  const {ref} = props;
  return (
    <DataFetcher
      request={useProductSelectionSection()}
      Error={null}
      Loading={() =>
        props.showProductSelectionAsGrid ? (
          <ProductSelectionGridSkeleton className={props.className} />
        ) : (
          <ProductSelectionSkeleton className={props.className} />
        )
      }
      View={ProductSelectionView}
      viewProps={{...props, ref}}
      renderingPriority={props.renderingPriority}
    />
  );
};
